import React from 'react'
import type { ProjectDetailStats } from '../../../types/projectAnalysis'
import { ProjectDetailOverviewKpis } from './project-detail-overview-kpis'

export interface ProjectDetailOverviewTabProps {
  stats: ProjectDetailStats
}

export function ProjectDetailOverviewTab({
  stats: s,
}: ProjectDetailOverviewTabProps) {
  return (
    <div className="space-y-4">
      <ProjectDetailOverviewKpis stats={s} />
    </div>
  )
}
